<template>
  <div id="hospital-list">
    <h3 class="title">海外生活</h3>
    <ul class="table">
      <li
        class="item"
        :class="{ activatedBgColor: index === current }"
        @click="handleItemClick(index, item.img)"
        v-for="(item, index) of list"
        :key="item.id"
      >
        <span class="title" :class="{ activatedColor: index === current }">{{
          item.hospitalName
        }}</span>
      </li>
    </ul>
    <ul class="img-list">
      <li class="img-item" v-for="item of imgList" :key="item.id">
        <img :src="item.url" alt="" />
        <h3 class="item-title">{{ item.title }}</h3>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HospitalList",
  components: {},
  data() {
    return {
      current: 0,
      imgList: [],
      list: [
        {
          id: 1,
          hospitalName: "MD安德森",
          img: [
            {
              id: 1,
              title: "海外酒店住宿环境1",
              url: require("../../../../assets/images/blueCross/md1.png")
            },
            {
              id: 2,
              title: "海外酒店周边环境1",
              url: require("../../../../assets/images/blueCross/md2.png")
            },
            {
              id: 3,
              title: "服务团队员工照片1",
              url: require("../../../../assets/images/blueCross/md3.png")
            },
            {
              id: 4,
              title: "服务团队员工照片1",
              url: require("../../../../assets/images/blueCross/md4.png")
            },
            {
              id: 5,
              title: "治疗期间丰富生活1",
              url: require("../../../../assets/images/blueCross/md5.png")
            }
          ]
        },
        {
          id: 2,
          hospitalName: "梅奥诊所",
          img: [
            {
              id: 1,
              title: "海外酒店住宿环境2",
              url: require("../../../../assets/images/blueCross/md5.png")
            },
            {
              id: 2,
              title: "海外酒店周边环境2",
              url: require("../../../../assets/images/blueCross/md4.png")
            },
            {
              id: 3,
              title: "服务团队员工照片2",
              url: require("../../../../assets/images/blueCross/md3.png")
            },
            {
              id: 4,
              title: "服务团队员工照片2",
              url: require("../../../../assets/images/blueCross/md2.png")
            },
            {
              id: 5,
              title: "治疗期间丰富生活2",
              url: require("../../../../assets/images/blueCross/md1.png")
            }
          ]
        },
        {
          id: 3,
          hospitalName: "丹娜法伯",
          img: [
            {
              id: 1,
              title: "海外酒店住宿环境3",
              url: require("../../../../assets/images/blueCross/md3.png")
            },
            {
              id: 2,
              title: "海外酒店周边环境3",
              url: require("../../../../assets/images/blueCross/md2.png")
            },
            {
              id: 3,
              title: "服务团队员工照片3",
              url: require("../../../../assets/images/blueCross/md4.png")
            },
            {
              id: 4,
              title: "服务团队员工照片3",
              url: require("../../../../assets/images/blueCross/md1.png")
            },
            {
              id: 5,
              title: "治疗期间丰富生活3",
              url: require("../../../../assets/images/blueCross/md5.png")
            }
          ]
        },
        {
          id: 4,
          hospitalName: "克利夫兰",
          img: [
            {
              id: 1,
              title: "海外酒店住宿环境4",
              url: require("../../../../assets/images/blueCross/md4.png")
            },
            {
              id: 2,
              title: "海外酒店周边环境4",
              url: require("../../../../assets/images/blueCross/md5.png")
            },
            {
              id: 3,
              title: "服务团队员工照片4",
              url: require("../../../../assets/images/blueCross/md1.png")
            },
            {
              id: 4,
              title: "服务团队员工照片4",
              url: require("../../../../assets/images/blueCross/md3.png")
            },
            {
              id: 5,
              title: "治疗期间丰富生活4",
              url: require("../../../../assets/images/blueCross/md2.png")
            }
          ]
        },
        {
          id: 5,
          hospitalName: "麻省总院",
          img: [
            {
              id: 1,
              title: "海外酒店住宿环境5",
              url: require("../../../../assets/images/blueCross/md5.png")
            },
            {
              id: 2,
              title: "海外酒店周边环境5",
              url: require("../../../../assets/images/blueCross/md1.png")
            },
            {
              id: 3,
              title: "服务团队员工照片5",
              url: require("../../../../assets/images/blueCross/md4.png")
            },
            {
              id: 4,
              title: "服务团队员工照片5",
              url: require("../../../../assets/images/blueCross/md2.png")
            },
            {
              id: 5,
              title: "治疗期间丰富生活5",
              url: require("../../../../assets/images/blueCross/md3.png")
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.imgList = this.list[0].img;
  },
  methods: {
    handleItemClick(index, item) {
      console.log(index);
      this.current = index;
      this.imgList = item;
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
#hospital-list {
  overflow: hidden;
  margin-top: 40px;
  .title {
    color: #535353;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 30px;
  }
  .table {
    height: 60px;
    display: flex;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
    border-top: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    .item {
      flex: 1;
      border-right: 1px solid #e5e5e5;
      cursor: pointer;
      .title {
        font-size: 20px;
        font-weight: 400;
        color: #545454;
        line-height: 60px;
      }
      .activatedColor {
        color: #3496e3;
      }
    }
  }
  .img-list {
    margin-top: 38px;
    display: flex;
    overflow: hidden;
    .img-item {
      flex: 1;
      margin-right: 26px;

      img {
        width: 100%;
        height: 250px;
      }
      .item-title {
        margin-top: 23px;
        font-size: 16px;
        color: #3c3c3c;
        text-align: center;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .activatedBgColor {
    background: #d2d2d2;
  }
}
</style>
